import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Heading from '../Heading/Heading'
import addIcon from '../../assets/icons/add.svg'
import arrowRightIcon from '../../assets/icons/arrow-right.svg'

const Col = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  width: 100%;

  ${p => (p.mt ? 'margin-top: 35px' : 'margin-left: 100px')};

  @media only screen and (max-width: 1400px) {
    ${p => !p.mt && 'margin-top: 80px'};
    margin-left: revert;
  }
`

const LinkBox = styled.div`
  height: 40px;
  width: 40px;
  background-color: var(--color-primary);
  box-shadow: 0 0 10px 0 rgba(151, 202, 111, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;

  img {
    filter: brightness(0);
  }
`

const BigLink = styled(Link)`
  width: 100%;
  background-color: var(--color-bg-sidebar);
  padding: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: background-color 0.2s ease;

  span {
    color: var(--color-text-primary);
    font-size: 16px;
    font-weight: bold;
  }

  &:hover {
    background-color: rgba(151, 202, 111, 0.2);
  }
`

const List = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`

const Item = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  span {
    color: var(--color-text-primary);
    font-size: 16px;
    font-weight: bold;
  }

  img {
    margin-left: auto;
    filter: brightness(0) invert(1);
    opacity: 0.6;
  }

  &:hover {
    background-color: var(--color-bg-sidebar);

    img {
      opacity: 1;
    }
  }
`

const Badge = styled.div`
  background-color: var(--color-primary);
  color: var(--color-bg-main);
  font-size: 16px;
  font-weight: bold;
  padding: 4px 9px;
  margin-left: 13px;
  border-radius: 6px;
`

const QuickLinks = ({ tickets }) => {
  const openTickets = tickets.items.length

  return (
    <Col>
      <Heading>Quick Links</Heading>
      <Col mt>
        <BigLink className='quick-links-open-new-support-case' to='/support-cases/new'>
          <LinkBox>
            <img src={addIcon} alt='icon' />
          </LinkBox>
          <span>Open a Request</span>
        </BigLink>
        <List>
          <Item className='quick-links-view-recent-support-cases' to='/support-cases'>
            <span>View Recent Support Cases</span>
            {!!openTickets && <Badge>{`${openTickets} Open`}</Badge>}
            <img src={arrowRightIcon} alt='icon' />
          </Item>
          <Item className='quick-links-see-trek10s-current-priorities' to='/priority-board'>
            <span>View Team Support Board</span>
            <img src={arrowRightIcon} alt='icon' />
          </Item>
        </List>
      </Col>
    </Col>
  )
}

export default QuickLinks
